(function (window, document) {
  window.componentEvents.on('consumer-rx-form-instantiate', init);

  /**
   * Instantiate a file upload UI.
   */
  function init(form) {
    const dropArea = form.querySelector('.upload-drop-area');
    const fileInput = form.querySelector('.upload-input');
    const removeFileButton = form.querySelector('.upload-delete');
    const step = fileInput.closest('[data-rx-step]');
    const uploadFileName = form.querySelector('.upload-file-name');
    const uploadFilePreview = form.querySelector('.upload-preview');

    removeFileButton.addEventListener('click', removeFile);
    window.componentEvents.on(`rx-form-upload-file-valid-${form.id}`, previewFile);
    window.componentEvents.on(`rx-form-upload-file-invalid-${form.id}`, removeFile);
    window.componentEvents.on(`rx-form-reset-${form.id}`, removeFile);
    window.componentEvents.on(`rx-form-partial-reset-${form.id}`, (data) => {
      // Only clear file preview if the event calls to reset this step.
      if (data.stepToReset === step.dataset.rxStep) {
        removeFile();
      }
    });

    /**
     * Clear the user’s file selection.
     */
    function removeFile() {
      // Remove the file from the input node.
      fileInput.value = null;
      // Clearing the file input node does not emit a native `change` event, so
      // we emit a custom event of our own (e.g. to trigger validation).
      window.componentEvents.emitEvent(`rx-form-file-upload-cleared-${form.id}`, [{
        uploadStepNumber: step.dataset.rxStep,
      }]);
      clearFilePreview();
    }

    /**
     * Preview the user’s selected file.
     */
    function previewFile() {
      const file = fileInput.files[0];
      // Add a thumbnail of the file to the previewer if the file is an image.
      if (file.type.match(/^image/)) {
        try {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = function() {
            const img = document.createElement('img');
            img.src = reader.result;
            // Clear file previews that may have already been injected.
            uploadFilePreview.querySelectorAll('img')
              .forEach((image) => image.remove());
            // Append new file preview.
            uploadFilePreview.appendChild(img);
            // Display the filename.
          }
        } catch (error) {
          // If any of the above throws an exception (due to an older browser
          // that doesn’t support the FileReader API, or a file was selected that
          // we can’t read as data URL for some reason), simply do nothing.
        }
      }
      uploadFileName.innerHTML = file.name;
      dropArea.classList.add('upload-active');
    };

    /**
     * Clear the file preview generated when the user selected a file to upload.
     */
    function clearFilePreview() {
      const image = uploadFilePreview.querySelector('img');
      if (image) image.remove();
      uploadFileName.innerHTML = '';
      dropArea.classList.remove('upload-active');
    }
  }
})(window, document);
